import { public_urls, externalLinks } from '../config';
import role from './role';

const {
  forecastQuoteAndDealList,
  forecastTotals,
  forecastSubscriptions,
  forecastFLMMap,
  otherTools,
  userLinks,
  qRadarPartDetails,
  reports,
  adminPage,
  applianceSN,
  termsOfUse,
  cadence,
} = public_urls;

const { privacyIBM, privacyBP } = externalLinks;

export const forecastNavigationLinks = [
  {
    link: forecastQuoteAndDealList,
    title: 'Quote & Deal List',
    isExternal: false,
  },
  {
    link: forecastTotals,
    title: 'Totals',
    isExternal: false,
  },
  {
    link: forecastSubscriptions,
    title: 'Subscriptions',
    isExternal: false,
    roles: [role.FORECAST_EDITOR],
  },
  {
    link: forecastFLMMap,
    title: 'FLM Map',
    isExternal: false,
    roles: [role.FORECAST_EDITOR],
  },
];

export const forecastDropdownLinks = {
  title: 'SASC Tools',
  links: [
    {
      link: otherTools.configurationTool,
      title: 'Configuration Tool',
      isExternal: true,
    },
    {
      link: otherTools.hwr,
      title: 'Hardware Refresh Tool',
      isExternal: true,
      roles: [role.HW_REFRESH_VIEWER, role.HW_REFRESH_FLM, role.HW_REFRESH_ADMIN],
    },
    {
      link: forecastQuoteAndDealList,
      title: 'Forecast Tool',
      isExternal: false,
      roles: [role.FORECAST_EDITOR, role.FORECAST_VIEWER],
    },
    {
      link: cadence,
      title: 'Cadence Tool',
      isExternal: false,
      roles: [role.CADENCE_EDITOR, role.CADENCE_VIEWER],
    },
    {
      link: otherTools.salesplay,
      title: 'Sales Play Tracker Tool',
      isExternal: true,
      roles: [role.SALESPLAY_EDITOR, role.SALESPLAY_ADMIN],
    },
    {
      link: otherTools.entitlement,
      title: 'Entitlements Tool',
      isExternal: true,
      roles: [role.ENTITLEMENT_VIEWER, role.ENTITLEMENT_FLM, role.ENTITLEMENT_ADMIN],
    },
    {
      link: otherTools.renewals,
      title: 'Renewals Tool',
      isExternal: true,
    },
    {
      link: otherTools.competitiveTakeout,
      title: 'Competitive Takeout',
      isExternal: true,
      roles: [role.COMPETITIVE_TAKEOUT_EDITOR],
    },
  ],
};

export const appDropdownLinks = [
  {
    link: '',
    title: 'Homepage',
    isExternal: false,
  },
  {
    link: termsOfUse,
    title: 'Terms of Use',
    isExternal: false,
    targetBlank: true,
  },
  {
    link: privacyIBM,
    title: 'Privacy',
    roles: [role.SELLER],
    isExternal: true,
    targetBlank: true,
  },
  {
    link: privacyBP,
    title: 'Privacy',
    roles: [role.BP],
    isExternal: true,
    targetBlank: true,
  },
];

export const manageDropdownLinks = [
  {
    link: userLinks.outOfOffice,
    title: 'Out-of-office settings',
    roles: [role.APPROVER, role.REVIEWER],
    isExternal: true,
  },
  {
    link: adminPage,
    title: 'Admin Page',
    roles: [role.ADMIN],
    isExternal: false,
  },
  {
    link: reports.base,
    title: 'Reports',
    roles: [role.ADMIN, role.HW_REFRESH_FLM, role.HW_REFRESH_ADMIN, role.ENTITLEMENT_FLM, role.ENTITLEMENT_ADMIN],
    isExternal: false,
  },
  {
    link: applianceSN,
    title: 'Appliance S/N',
    roles: [
      role.ADMIN,
      role.HW_REFRESH_VIEWER,
      role.HW_REFRESH_FLM,
      role.HW_REFRESH_ADMIN,
      role.ENTITLEMENT_VIEWER,
      role.ENTITLEMENT_FLM,
      role.ENTITLEMENT_ADMIN,
    ],
    isExternal: false,
  },
  {
    link: qRadarPartDetails,
    title: 'QRadar Parts Details',
    roles: [role.ADMIN],
    isExternal: false,
  },
];

export const reportsNavigationLinks = [
  {
    title: 'Management',
    links: [
      {
        link: reports.toolsReports,
        title: 'Tools Reports',
        isExternal: false,
      },
      {
        link: reports.hwrMonthlyReports,
        title: 'HWR Monthly Reports',
        isExternal: false,
      },
      {
        link: reports.metricsReport,
        title: 'Metrics Report',
        isExternal: false,
      },
      {
        link: reports.usersReport,
        title: 'Users Report',
        isExternal: false,
      },
      {
        link: reports.requestSupportReport,
        title: 'Request Support Report',
        isExternal: false,
      },
    ],
    roles: [role.ADMIN],
    isExternal: false,
  },
  {
    link: reports.entitlements,
    title: 'Entitlements',
    roles: [role.ADMIN, role.ENTITLEMENT_ADMIN, role.HW_REFRESH_ADMIN],
    isExternal: false,
  },
  {
    link: reports.dataLoadLogs,
    title: 'Data Load Logs',
    roles: [role.ADMIN, role.ENTITLEMENT_ADMIN, role.HW_REFRESH_ADMIN],
    isExternal: false,
  },
];
